import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { Input } from "@angular/core";
import { UtilsResourceService, Pays, AdresseDTO } from "@com.sofaxis/sofaxis-fonpel-espace-elus-ws-ts/dist";
import { ViewEncapsulation } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { ControlContainer } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Validators } from "@angular/forms";
import { NotificationService } from "src/app/api/notification.service";

@Component( {
    selector: 'app-infosNaissanceDialog-part',
    templateUrl: './infosNaissanceDialog-part.component.html',
    styleUrls: ['./infosNaissanceDialog-part.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    encapsulation: ViewEncapsulation.None
} )
export class InfosNaissanceDialogPartComponent implements OnInit {
    public listePays: Array<Pays>;
    public listeVilles: Array<String>;
    formGroup: FormGroup;
    PaysParDefaut: Pays;
    public ZipCodeRegex = /^\d{5}$/;

    paysNaissance: Pays;
    dateNaissance;
    villeNaissance;
    codePostal;

    constructor( public dialogRef: MatDialogRef<InfosNaissanceDialogPartComponent>, @Inject( MAT_DIALOG_DATA ) public data, private notificationService: NotificationService, private utilsService: UtilsResourceService, private _formBuilder: FormBuilder ) {

        this.paysNaissance = data.paysNaissance;
        this.dateNaissance = data.dateNaissance;
        this.villeNaissance = data.villeNaissance;
        this.codePostal = data.codePostalNaissance;

    }
    getPays() {
        this.PaysParDefaut = { codePays: 235, libelle: "FRANCE" };
        if ( this.paysNaissance == undefined || this.paysNaissance == null ) {
            return this.PaysParDefaut;
        }
        return this.paysNaissance;
    }
    ngOnInit() {
        this.formGroup = this._formBuilder.group( {
            dateNaissance: [this.dateNaissance, Validators.required],
            villeNaissance: [this.villeNaissance, Validators.required],
            codePostal: [this.codePostal, Validators.required],
            paysNaissance: [this.getPays(), Validators.required],
        } );
        this.utilsService.getListePays().subscribe( result => {
            this.listePays = result;

        } )
    }
    ngAfterViewInit() {
        if ( this.formGroup.get( 'paysNaissance' ) !== undefined && this.formGroup.get( 'paysNaissance' ).value.codePays == 235 ) {
            this.formGroup.get( 'codePostal' ).setValidators( [Validators.required, Validators.pattern( this.ZipCodeRegex )] );
            this.formGroup.get( 'codePostal' ).updateValueAndValidity();
        }
    }
    compareObjects( o1: Pays, o2: Pays ): boolean {
        return o1 && o2 ? o1.codePays === o2.codePays : o1 === o2;
    }

    codePostalModifie( $value: string ) {
        this.formGroup.get( 'villeNaissance' ).setValue( '' );
        this.villeParCodePostal( $value );
    }
    villeParCodePostal( $codePostal: string ) {
        this.listeVilles = [];
        if ( $codePostal.length >= 3 && this.formGroup.get( 'paysNaissance' ).value.codePays == 235 ) {
            this.utilsService.getCodePostauxVillesParCodePostal( $codePostal ).subscribe( result => {
                for ( const entry of Object.entries( result ) ) {
                    let codePostal = Object.keys( entry[1] )[0];
                    let ville = Object.values( entry[1] )[0];
                    this.listeVilles.unshift( codePostal + " " + ville );
                }
            } )
        }

    }
    onSelectionCodePostal( entry: string ) {
        this.formGroup.get( 'codePostal' ).setValue( entry.substring( 0, 5 ) );
        this.formGroup.get( 'villeNaissance' ).setValue( entry.substring( 5 ) );
    }

    onRecherchePaysChange() {
        if ( this.formGroup.get( 'paysNaissance' ).value.codePays == 235 ) {
            this.formGroup.get( 'codePostal' ).setValidators( [Validators.required, Validators.pattern( this.ZipCodeRegex )] );
        } else {

            this.formGroup.get( 'codePostal' ).setValidators( [Validators.required] );
        }
        this.listeVilles = [];

        this.formGroup.get( 'codePostal' ).setValue( '' );
        this.formGroup.get( 'villeNaissance' ).setValue( '' );
        this.formGroup.get( 'codePostal' ).updateValueAndValidity();
        this.formGroup.get( 'villeNaissance' ).updateValueAndValidity();
    }

    onNoClick(): void {
        this.dialogRef.close( { valid: false } );
    }
    toUpperCase( chaine ) {
        if ( chaine !== undefined && chaine != null ) {
            return chaine.toUpperCase();
        }
        return chaine;

    }

    onValider(): void {
        for ( let i in this.formGroup.controls )
            this.formGroup.controls[i].markAsTouched();
        if ( this.formGroup.valid ) {
            this.dialogRef.close( {
                valid: true,
                codePostalNaissance: this.formGroup.get( "codePostal" ).value,
                villeNaissance: this.formGroup.get( "villeNaissance" ).value,
                dateNaissance: this.formGroup.get( "dateNaissance" ).value,
                paysNaissance: this.formGroup.get( "paysNaissance" ).value

            } );
        } else {
            this.notificationService.warnCourt( 'Votre formulaire contient des erreurs. Veuillez corriger ces erreurs. ' );
        }
    }
}
